import { render, staticRenderFns } from "./ReceiveTransfer.vue?vue&type=template&id=2dc91b08&"
import script from "./ReceiveTransfer.vue?vue&type=script&lang=js&"
export * from "./ReceiveTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports